var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(1.000000, 0.000000)",
    fill: "#006F44",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,5.5 L-0.5,5.5 L-0.5,16.5 L16.5,16.5 L16.5,5.5 Z M15.5,6.5 L15.5,15.5 L0.5,15.5 L0.5,6.5 L15.5,6.5 Z",
    id: "Rectangle-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,1.5 L-0.5,1.5 L-0.5,6.5 L16.5,6.5 L16.5,1.5 Z M15.5,2.5 L15.5,5.5 L0.5,5.5 L0.5,2.5 L15.5,2.5 Z",
    id: "Rectangle-path-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.5 0 11.5 3 10.5 3 10.5 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-2",
    points: "5.5 0 5.5 3 4.5 3 4.5 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.dde4e4f0df8f12c655bb3a3e98531509.svg";
export { ForwardRef as ReactComponent };